import {Injectable} from '@angular/core'
import {TranslateService} from '@ngx-translate/core'
import {DEFAULT_LANG_UUID} from '../../shared/consts'

export function extract(key: string): string {
  return key
}

@Injectable()
export class I18nService {
  constructor(private translate: TranslateService) {
    /**
     * TODO
     */
    translate.addLangs(['cs'])

    translate.setDefaultLang('cs')
    translate.use('cs')
  }

  tr(key: string) {
    return this.translate.instant(key)
  }

  toViewWithDefault(langValue: any, defaultValue: string = '-') {
    if (!langValue) {
      return defaultValue
    }

    const defaultLanguageUuid: string = DEFAULT_LANG_UUID
    if (langValue.hasOwnProperty(defaultLanguageUuid)) {
      return langValue[defaultLanguageUuid]
    }

    return defaultValue
  }
}
